class MegaNav extends HTMLElement {
  constructor () {
    super()
  }

  setElements () {
    this.elements = {
      subNavs: this.querySelectorAll('[data-mega-nav-el="subNav"]'),
      triggers: this.querySelectorAll('[data-mega-nav-trigger]'),
      targets: this.querySelectorAll('[data-mega-nav-target]'),
      mediaTriggers: this.querySelectorAll('[data-mega-nav-media-trigger]'),
      allMedia: this.querySelectorAll('[data-mega-nav-media-handle]'),
      defaultMedia: this.querySelectorAll('[data-mega-nav-media-handle][data-default]'),
    }
  }

  show (el) {
    el.setAttribute('aria-hidden', false)
  }

  hide (el) {
    el.setAttribute('aria-hidden', true)
  }

  hideAll (els) {
    els.forEach((el) => {
      this.hide(el)
    })
  }

  showAll (els) {
    els.forEach((el) => {
      this.show(el)
    })
  }

  hideAllMedia () {
    this.hideAll(this.elements.allMedia)
  }

  showDefaultMedia () {
    this.hideAllMedia()
    this.elements.defaultMedia.forEach((item) => {
      this.show(item)
    })
  }

  setupListeners () {
    this.elements.subNavs.forEach(subNav => {
      subNav.addEventListener('mouseenter', () => {
        this.hideAll(this.elements.targets)
      })

      subNav.addEventListener('mouseleave', () => {
        this.showDefaultMedia()
      })
    })

    this.elements.mediaTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', (evt) => {
        const handle = trigger.dataset.megaNavMediaTrigger
        const parentHandle = trigger.dataset.megaNavMediaParent

        if (handle) {
          this.hideAllMedia()
          const targets = this.querySelectorAll(`[data-mega-nav-media-handle="${handle}"]`)
          const parents = this.querySelectorAll(`[data-mega-nav-media-handle="${parentHandle}"]`)

          if (targets.length > 0) {
            this.showAll(targets)

          } else if (parents.length > 0) {
            this.showAll(parents)
          } else {
            this.showDefaultMedia()
          }
        }
      })
    })

    this.elements.triggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        this.hideAll(this.elements.targets)

        const attr = trigger.dataset.megaNavTrigger
        const target = this.querySelector(`[data-mega-nav-target="${attr}"]`)

        if (target) {
          this.show(target)
        }
      })
    })
  }

  connectedCallback () {
    this.setElements()
    this.setupListeners()
  }
}

if (!customElements.get('mega-nav')) {
  customElements.define('mega-nav', MegaNav)
}
